/* @flow */
/*jshint esversion: 6 */

import React, { Component } from "react";
import "../App.css";
import { Button, Modal } from "antd";
import LangContext from "../contextProvider/LangContext";
import GenericModal from "./GenericModal";
import GenericTable from "./GenericTable";
import moment from "moment";

class ModalLastPrices extends Component {

    constructor(props) {
        super(props);
        this.state = {}
        this.id = "LAST_DOCS_CUST_ITEM";
        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData }

        this.api = {
            get: "get_last_docs_cust_item"
        }
    }


    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }



    handleOk = (record) => {
        const { unitPriceNoTax,  taxTypeID,  discountPercentage, remarks, updatedWithTax, updatedTaxValue, isChanged } = record;
        const { quantity } = this.props.editedRecord;
        const updateRow = () => {
            this.props.onChange({
                ...this.props.editedRecord,
                unitPriceNoTax,
                unitPriceWithTax: updatedWithTax,
                totalSumNoTax: (parseFloat(unitPriceNoTax) * quantity * (1 - discountPercentage / 100)).toFixed(4),
                totalSumWithTax: (parseFloat(updatedWithTax) * quantity * (1 - discountPercentage / 100)).toFixed(2),
                taxTypeID,
                taxValue: updatedTaxValue,
                discountPercentage,
                remarks,
            })
            this.props.onCancel()
        }

        if (isChanged == 1) {
            Modal.confirm({
                content: (<h4>{this.getText(21778)}</h4>),
                iconType: 'exclamation-circle',
                okButtonProps: { style: { display: 'none' } },
                cancelText: this.getText(21779),
                onOk() { },
                onCancel: updateRow,
            })
        } else {
            updateRow()
        }

    }



    render() {

        const { visible, onCancel, editedRecord, data, documentType } = this.props;
        console.log("ModalLastPrices", this.props)
        return (<GenericModal {...{ visible, onCancel }}
            title={this.getText(20486)}
            width={1000}>
            {this.props.visible ?
                <GenericTable
                    {...this.props}
                    tableOnly
                    id={this.id}
                    getApi={this.api.get}
                    filters={{
                        _cust: data.document2.customerCode,
                        _item: editedRecord.itemCode,
                        _isSupp: [4, 16, 17, 18, 20, 21].find(f => f == documentType) ? '1' : '0',
                        mTargetDate: moment(data.document2.docDateTime).format("YYYY-MM-DD"),
                        mDocPos: this.props.posId,
                    }}
                    columns={[
                        { title: this.getText(20487), key: "sourceDocNum", dataIndex: "sourceDocNum", render: t => t },
                        { title: this.getText(21180), key: "sourceDocTypeName", dataIndex: "sourceDocTypeName", render: t => t },
                        { title: this.getText(20488), key: "sourceDocDatetime", dataIndex: "sourceDocDatetime", render: t => moment(t).format("DD/MM/YYYY HH:mm") },
                        { title: this.getText(20489), key: "unitPriceNoTax", dataIndex: "unitPriceNoTax", render: t => t },
                        { title: this.getText(20490), key: "unitPriceWithTax", dataIndex: "unitPriceWithTax", render: t => t },
                        { title: this.getText(20491), key: "discountPercentage", dataIndex: "discountPercentage", render: t => t },
                        { title: this.getText(22893), key: "iQty", dataIndex: "iQty", render: t => t },
                        { title: "", render: (t, r) => (<Button onClick={() => { this.handleOk(r) }}>{this.getText(20492)}</Button>) },
                    ]}
                />
                : ""}
        </GenericModal>)
    }
}

export default ModalLastPrices;